import { useQuery } from "@/api/utils/useQuery"
import { ApiGatewayQueries } from "@/api/apiGateway/queries"
import { ICancellationReason } from "@/models/cancellationReason/cancellationReason.types"

class CancellationReasonServiceClass {
  getForAccountMeterpoint(accountNumber: string, meterpointId: number) {
    return useQuery({
      ...ApiGatewayQueries.cancellationReason.details(
        accountNumber,
        meterpointId,
      ),
      parserFn: (
        rawData: ICancellationReason[],
      ): ICancellationReason | undefined => rawData[0],
    })
  }
}

export const CancellationReasonService = new CancellationReasonServiceClass()
